export { castArray as ensureArray } from 'lodash-unified';

const unique = (arr) => [...new Set(arr)];
const castArray = (arr) => {
  if (!arr && arr !== 0)
    return [];
  return Array.isArray(arr) ? arr : [arr];
};

export { castArray, unique };
//# sourceMappingURL=arrays.mjs.map
